import AppPrevious from 'App';
import { Amplify } from 'aws-amplify';
import ReactDOM from 'react-dom/client';
import AppNext from 'v2/App';
import { featureFlagEnabled } from 'v2/utils/featureFlagEnabled';
import awsConfig from './environment/AwsCognitoConfig';

import '@fontsource/rubik/300.css';
import '@fontsource/rubik/400.css';
import '@fontsource/rubik/500.css';

Amplify.configure(awsConfig);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const isNewGuiEnabledInEnv = process.env.REACT_APP_IS_NEW_GUI_ENABLED === 'true';

const isNewGuiEnabled = () => {
  if (featureFlagEnabled('OLD', false)) return false;
  if (isNewGuiEnabledInEnv || featureFlagEnabled('NEXT', false)) return true;
  return false;
};

root.render(isNewGuiEnabled() ? <AppNext /> : <AppPrevious />);
